export default RAILS_ASSET_URL("/logo.png")
